import { Component, OnInit, ViewChild } from '@angular/core';
import { SidenavComponent, ToastService } from 'ng-uikit-pro-standard';
import { KeycloakService } from 'keycloak-angular';
import { AppConstants } from '../config.service';
import { AuthService } from '../auth.service';
import { SharedService } from '../shared/shared.service';
import { finalize } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  user: any;
  userEmailAddress: any = {};
  loggedInUserInitials: string;
  userRolesLoader: boolean = false;
  switchAppEndPoint: String;
  sub: Subscription;
  roleAccessSubscription: Subscription;

  constructor(
    private keycloakService: KeycloakService,
    private sharedService: SharedService,
    private appConstants: AppConstants,
    private authService: AuthService,
    private translate: TranslateService,
    public toastr: ToastService
  ) {
      this.userPreferenceCdnUrl =this.appConstants.endPoints.webComponentsEndPoint + 'user-preference-modal/user-preferences-modal.js'
      this.notificationCompCdnUrl = this.appConstants.endPoints.webComponentsEndPoint + 'notification-element/notification-component.js';
      this.switchAppDropDownCdnUrl = this.appConstants.endPoints.webComponentsEndPoint + 'switch-app-dropdown/js/switch-app-dropdown.js';
    this.sub = this.authService.checksprigAvailable.subscribe(data => {
      if (data && data.sprigNotAvailable)
        this.showDocWarningModal(data)
    })

    this.roleAccessSubscription = this.authService.roleAccessSubscription.subscribe(data => {
      this.canShowHeader = data;
    })
  }
  
  queuesOpened:boolean=false;
  certificationCanApproveReports: boolean = false;
  certificationCanManageCustomers: boolean = false;
  canViewNewFeatures: boolean = false;
  certificationAdministration: boolean = false;
  canViewCorrespondanceQueues: boolean = false;
  canViewRequests: boolean = false;
  canViewDashBoard: boolean = false;
  canViewCertificateTools: boolean = false;
  canViewComponents: boolean = false;
  canViewcreateComponentSelections: boolean = false;
  canViewCustomerSelections: boolean = false;
  canViewSearchSelections: boolean = false;
  canViewSearchNotifications: boolean = false;
  canViewSearchComponents: boolean = false;
  canGenerateSuspensionNotices: boolean = false;

  @ViewChild('sidenav',{static:true}) sidenav : SidenavComponent
  
  dropDownSendData:any = {};
  canShowHeader : any = false;
  notificationCompCdnUrl  :string = "";
  switchAppDropDownCdnUrl  :string = "";
  async ngOnInit() {
    if (await this.keycloakService.isLoggedIn()) {
      this.appConstants.checkAuth();
      const user = this.appConstants.userDetails

      const token = await this.keycloakService.getToken();
      this.sendToken = {
        token: token
      };
      await this.appConstants.getTenantId();
      this.dropDownSendData = {
        url : this.appConstants.endPoints.tenantEndPoint + this.appConstants.tenantId + '/users/' + user.email + '/applications', 
        params:{
        },
        imageBasePath : this.appConstants.endPoints.webComponentsEndPoint + 'switch-app-dropdown/images/app-icons/'              
    }

      setInterval(() => {
        this.getToken();
      }, 1000);
      this.setUserPreferenceModalData();
      this.certificationCanApproveReports = await this.authService.checkRoleExist('certificationCanApproveReports');
      this.certificationCanManageCustomers = await this.authService.checkRoleExist('certificationCanManageCustomers');
      this.canViewNewFeatures = await this.authService.checkRoleExist('canViewNewFeatures');
      this.canViewCorrespondanceQueues = await this.authService.checkRoleExist('certificationCorrespondenceQueues');
      this.canViewRequests = await this.authService.checkRoleExist('certificationQueues');
      this.canViewDashBoard = await this.authService.checkRoleExist('certificationDashboard');
      this.canViewCertificateTools = await this.authService.checkRoleExist('certificationTools');
      this.canViewComponents = await this.authService.checkRoleExist('components');
      this.canViewCustomerSelections = await this.authService.checkRoleExist('CustomerSelections');
      this.canViewSearchSelections = await this.authService.checkRoleExist('SearchSelections');
      this.canViewSearchNotifications = await this.authService.checkRoleExist('SearchNotifications');
      this.canViewSearchComponents = await this.authService.checkRoleExist('SearchComponents');
      this.canViewcreateComponentSelections = await this.authService.checkRoleExist('createComponentSelections');
      this.certificationAdministration = await this.authService.checkRoleExist('certificationAdministration');
      this.canGenerateSuspensionNotices = await this.authService.checkRoleExist('canGenerateSuspensionNotices');
      this.userEmailAddress = user.email
      this.user = user.firstName + ' ' + user.lastName
      this.loggedInUserInitials = this.user.match(/\b(\w)/g).join('');
    }


    let selectionInterval = setInterval(() => {
      this.isSelectionCreationInProgress();
    }, 60000)
    this.notificationCount();
    let Interval = setInterval(() => {
      this.notificationCount();
    }, this.appConstants.endPoints.notificationCountInterval)
  }

  ngOnDestroy() {
    if (this.sub)
      this.sub.unsubscribe();
    if(this.roleAccessSubscription)
    this.roleAccessSubscription.unsubscribe()
  }

  public msgCount: number;
  notificationCount() {
    this.sharedService.get(this.appConstants.endPoints.notificationEndPoint + 'unread-count', { destinationAddress: this.userEmailAddress })
      .subscribe(data => {
        this.msgCount = data
      }, error => {

      });
  }


  async logout() {
    const localStorgeAttributes = [
      "isSprigEnabled",
      "selectedDevice",
      "selected-filter"
    ];
    for (let index = 0; index < localStorgeAttributes.length; index++) {
      const element = localStorgeAttributes[index];
      localStorage.removeItem(element);
    }
    await this.keycloakService.logout();
  }

  notificationInfo: any = {};
  isDrawerOpen = false;

  async toggleShowDrawer() {
    this.isDrawerOpen = !this.isDrawerOpen;
    let notificationsData;
    if (this.isDrawerOpen) {
      const token = await this.keycloakService.getToken();
      notificationsData = {
        headers: {
          token: token,
          customerId: "",
        },
        unread: {
          url: this.appConstants.endPoints.notificationEndPoint + 'unread',
          params: { destinationAddress: this.userEmailAddress }
        },
        markAsRead: {
          url: this.appConstants.endPoints.notificationEndPoint + 'mark-as-read',
          params: { destinationAddress: this.userEmailAddress }
        },
        markAllRead: {
          url: this.appConstants.endPoints.notificationEndPoint + 'mark-all-read',
          params: { destinationAddress: this.userEmailAddress }
        }
      }
      notificationsData['isOpen'] = true;
      this.notificationInfo = { ...{}, ...notificationsData };
    }
    else {
      this.notificationInfo = { isOpen: false };
    }
  }

  closeNotification(e) {
    this.isDrawerOpen = false;
  }

  selections: any = [];
  selectionCreationInProgress: boolean = false;
  isSelectionCreationInProgress() {
    let url = this.appConstants.endPoints.certificatesEndPoint + 'critical-components/query-component-selection-processes';
    this.sharedService.post(url, {
      "runningOnly": true,
      "pageNumber": 1,
      "pageSize": 25
    }, {})
      .pipe(finalize(() => {
        //
      })).subscribe(res => {
        if (res) {
          //debugger
          this.selectionCreationInProgress = true;
          setTimeout(() => { this.selectionCreationInProgress = false }, 5000)
          this.selections = res ? res.searchResults : []
        }
        else {
          //debugger
          this.selectionCreationInProgress = false;
        }
        //console.log(res)
      })
  };

  @ViewChild('selectionCreationModal', { static: true }) selectionCreationModal: any;
  openSelectionCreationModal() {
    this.selectionCreationModal.show();
    this.isSelectionCreationInProgress();
  }

  sendToken: any = {};
  async getToken() {
    let token
    if (await this.keycloakService.isLoggedIn()) {
      token = await this.keycloakService.getToken();
      this.sendToken = Object.assign({}, {
        token: token
      })
    }
  }

  openUserPreferencesModal(){
    //TODO:
    this.open()
  }

  sprigWarningData: any = {}
  showDocWarningModal(obj) {
    this.sprigWarningData = { ...{}, ...obj }
  }

  userPreferenceCdnUrl: string = "";
  endpoints: any = {}
  async setUserPreferenceModalData() {
    let token = await this.keycloakService.getToken();
    this.sendToken = Object.assign({}, {
      token: token
    })
    let endpoint = {
      appliances: this.appConstants.endPoints.sprigEndPoint + 'admin/',
      sprigEndPoints: this.appConstants.endPoints.sprigEndPoint,
    }
    this.endpoints = { ...{}, ...endpoint }  
  }

  userPreferencesData: any = {};
  async open() {
    const user = this.appConstants.userDetails;
    const token = await this.keycloakService.getToken();
    this.sendToken = {
      token: token
    };

    setInterval(() => {
      this.getToken();
    }, 1000);
    let endpoint = {
      schedulesEndpoint: this.appConstants.endPoints.scheduleEndpoint,
      samplesEndpoint: this.appConstants.endPoints.sampleTrackerEndpoint,
      tenantEndPoint: this.appConstants.endPoints.tenantEndPoint,
      messageNotificationEndPoint: this.appConstants.endPoints.notificationEndPoint,
      reportServicesEndPoint: this.appConstants.endPoints.reportServicesEndPoint,
      appliances: this.appConstants.endPoints.sprigEndPoint + 'admin/',
      sprigEndPoints: this.appConstants.endPoints.sprigEndPoint,
      resourcesEndPoint: this.appConstants.endPoints.resourcesEndPoint
    }
    let obj = {}
    obj['userInfo'] = this.appConstants.userDetails
    obj['endPoints'] = endpoint
    obj['showModal'] = true
    this.userPreferencesData = { ...{}, ...obj }
  }

  langChanged(lang) {
    if (lang && lang.detail)
      this.translate.use(lang.detail).subscribe(res => { },
        err => {
          this.toastr.warning(this.translate.instant('administration_langNotSupported_label'));
          this.translate.use('en');
          const userSettings = { preferredLanguageCode: 'en' };
          localStorage.setItem("userSettingsJson", JSON.stringify(userSettings));
        })
  }

  toastMessages(message) {
    if (message && message.detail) {
      let toastMessage = message.detail
      if (toastMessage && toastMessage.success)
        this.toastr.success(toastMessage.success)
      else 
        this.toastr.success(toastMessage.error.errorMessage)
    }
  }

  defaultSprigInfo: any = {}
  getSprigInfo(event) {
    if (event && event.detail) {
      this.defaultSprigInfo = { ...{}, ...event.detail }
    }
  }

}